/**
 * Tam çerçeve / içerik slaytları: yalnızca görünür slayttaki video oynasın.
 * Lazy (data-ed-lazy-video / data-src) kaynakları görünür olunca yükler.
 */
import { SlideshowSelectEvent } from '@theme/events';

/**
 * @param {HTMLVideoElement} video
 */
function loadAndPlay(video) {
  const perf = (typeof window !== 'undefined' && window.__edPerf) || {};
  if (perf.noVideoAutoplay) {
    video.pause();
    return;
  }

  let loaded = false;
  video.querySelectorAll('source[data-src]').forEach((source) => {
    if (!source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.src);
      loaded = true;
    }
  });
  if (loaded) {
    try {
      video.load();
    } catch {
      /* ignore */
    }
  }
  video.muted = true;
  video.play().catch(() => {});
}

/**
 * @param {HTMLVideoElement} video
 */
function unloadVideo(video) {
  video.pause();
  let changed = false;
  video.querySelectorAll('source[src]').forEach((source) => {
    if (!source.dataset.src) {
      source.dataset.src = source.getAttribute('src');
    }
    source.removeAttribute('src');
    changed = true;
  });
  if (changed) {
    try {
      video.load();
    } catch {
      /* ignore */
    }
  }
}

/**
 * @param {Element} slideshow
 */
function syncSlideshowVideos(slideshow) {
  if (!slideshow?.querySelectorAll) return;

  const perf = (typeof window !== 'undefined' && window.__edPerf) || {};
  const noAutoplay = !!perf.noVideoAutoplay;

  slideshow.querySelectorAll('slideshow-slide').forEach((slide) => {
    const video = slide.querySelector('video.slide__video');
    if (!(video instanceof HTMLVideoElement)) return;

    const hidden = slide.getAttribute('aria-hidden') === 'true';
    if (hidden || noAutoplay) {
      unloadVideo(video);
    } else {
      loadAndPlay(video);
    }
  });
}

/**
 * @param {Event} event
 */
function onSlideshowSelect(event) {
  const slideshow = event.target?.closest?.('slideshow-component');
  if (!slideshow || slideshow.hasAttribute('data-video-carousel')) return;
  syncSlideshowVideos(slideshow);
}

function initSlideshowVideos() {
  document.querySelectorAll('slideshow-component:not([data-video-carousel])').forEach((el) => {
    syncSlideshowVideos(el);
  });
}

document.addEventListener(SlideshowSelectEvent.eventName, onSlideshowSelect);

document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    initSlideshowVideos();
    requestAnimationFrame(initSlideshowVideos);
  });
});

document.addEventListener('shopify:section:load', () => {
  requestAnimationFrame(initSlideshowVideos);
});
